(function () {

  // ─── IDs de variante de productos ───────────────────────────────
  const PRODUCTS = {
    ACG:  56061902586204,
    AASB: 56062152638812,
    RCYS: 56062167056732,
    RCMS: 56062174658908,
    FECC: 56062183440732,
    RBNC: 56062227186012,
  };

  // ─── IDs de variante de muestras ────────────────────────────────
  const SAMPLES = {
    S_AASB: 56889935888732,
    S_RCMS: 56889941819740,
    S_FECC: 56889952076124,
  };

  const ALL_SAMPLE_IDS = Object.values(SAMPLES);

  // Discovery Routine Set no participa en ninguna regla de muestras:
  // ni cuenta para el total, ni genera muestra, ni la recibe.
  const DISCOVERY_SET_VARIANT_ID = 57423024619868;
  const EXCLUDED_FROM_RULE_IDS = ALL_SAMPLE_IDS.concat([DISCOVERY_SET_VARIANT_ID]);

  // ─── Tablas muestras ─────────────────────────────────────────────
  const MAP_1 = {
    [PRODUCTS.ACG]:  SAMPLES.S_AASB,
    [PRODUCTS.AASB]: SAMPLES.S_RCMS,
    [PRODUCTS.RCMS]: SAMPLES.S_FECC,
    [PRODUCTS.RCYS]: SAMPLES.S_AASB,
    [PRODUCTS.FECC]: SAMPLES.S_RCMS,
    [PRODUCTS.RBNC]: SAMPLES.S_FECC,
  };

  const MAP_2 = {
    [`${PRODUCTS.ACG}_${PRODUCTS.AASB}`]:  [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [`${PRODUCTS.ACG}_${PRODUCTS.RCMS}`]:  [SAMPLES.S_AASB, SAMPLES.S_FECC],
    [`${PRODUCTS.ACG}_${PRODUCTS.RCYS}`]:  [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [`${PRODUCTS.ACG}_${PRODUCTS.FECC}`]:  [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [`${PRODUCTS.ACG}_${PRODUCTS.RBNC}`]:  [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [`${PRODUCTS.AASB}_${PRODUCTS.RCMS}`]: [SAMPLES.S_FECC, SAMPLES.S_AASB],
    [`${PRODUCTS.AASB}_${PRODUCTS.RCYS}`]: [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [`${PRODUCTS.AASB}_${PRODUCTS.FECC}`]: [SAMPLES.S_RCMS, SAMPLES.S_AASB],
    [`${PRODUCTS.AASB}_${PRODUCTS.RBNC}`]: [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [`${PRODUCTS.RCMS}_${PRODUCTS.RCYS}`]: [SAMPLES.S_AASB, SAMPLES.S_FECC],
    [`${PRODUCTS.RCMS}_${PRODUCTS.FECC}`]: [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [`${PRODUCTS.RCMS}_${PRODUCTS.RBNC}`]: [SAMPLES.S_AASB, SAMPLES.S_FECC],
    [`${PRODUCTS.RCYS}_${PRODUCTS.FECC}`]: [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [`${PRODUCTS.RCYS}_${PRODUCTS.RBNC}`]: [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [`${PRODUCTS.FECC}_${PRODUCTS.RBNC}`]: [SAMPLES.S_AASB, SAMPLES.S_RCMS],
  };

  const MAP_2_SAME = {
    [PRODUCTS.ACG]:  [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [PRODUCTS.AASB]: [SAMPLES.S_RCMS, SAMPLES.S_FECC],
    [PRODUCTS.RCMS]: [SAMPLES.S_AASB, SAMPLES.S_FECC],
    [PRODUCTS.RCYS]: [SAMPLES.S_AASB, SAMPLES.S_FECC],
    [PRODUCTS.FECC]: [SAMPLES.S_AASB, SAMPLES.S_RCMS],
    [PRODUCTS.RBNC]: [SAMPLES.S_RCMS, SAMPLES.S_FECC],
  };

  // ─── Calcular muestras ───────────────────────────────────────────
  function getSamplesToAdd(cartItems) {
    const realItems = cartItems.filter(i => !EXCLUDED_FROM_RULE_IDS.includes(i.variant_id));
    const totalQty  = realItems.reduce((sum, i) => sum + i.quantity, 0);

    if (totalQty === 0) return [];
    if (totalQty >= 3) return Object.values(SAMPLES);

    if (totalQty === 1) {
      const s = MAP_1[realItems[0].variant_id];
      return s ? [s] : [];
    }

    if (totalQty === 2) {
      if (realItems.length === 1) return MAP_2_SAME[realItems[0].variant_id] || [];
      const ids = realItems.map(i => i.variant_id).sort((a, b) => a - b);
      return MAP_2[ids.join('_')] || [];
    }

    return [];
  }

  // ─── Eliminar todas las muestras ────────────────────────────────
  async function removeSamples() {
    const updates = {};
    ALL_SAMPLE_IDS.forEach(id => { updates[id] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  // ─── Añadir una muestra ──────────────────────────────────────────
  async function addSample(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gift: 'true' } })
    });
  }

  // ─── Limpiar muestras del carrito ───────────────────────────────
  async function cleanCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const hasSamples = cart.items.some(i => ALL_SAMPLE_IDS.includes(i.variant_id));
      if (hasSamples) await removeSamples();
      updateCartCount(cart.items);
            // Mostrar/ocultar banner
      const hasEligible = cart.items.some(i =>
        Object.values(PRODUCTS).includes(i.variant_id)
      );
      document.querySelectorAll('#gift-samples-banner').forEach(el => {
        el.style.display = hasEligible ? 'block' : 'none';
      });
    } catch (err) {
      console.error('[GiftSamples] cleanCart error:', err);
    }
  }

  // ─── Aplicar muestras antes del checkout ────────────────────────
  async function applyBeforeCheckout() {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const samplesToAdd = getSamplesToAdd(cart.items);
    await removeSamples();
    for (const variantId of samplesToAdd) {
      await addSample(variantId);
    }
  }

  // ─── Interceptar checkout ────────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('button, a, input[type="submit"]');
    if (!btn) return;

    const text = (btn.innerText || btn.value || '').toLowerCase().trim();
    const href = btn.getAttribute('href') || '';
    const name = btn.getAttribute('name') || '';
    const id   = btn.getAttribute('id')   || '';

    const isCheckout =
      name === 'checkout'            ||
      id   === 'CartDrawer-Checkout' ||
      href.includes('/checkout')     ||
      text.includes('pasar por la caja') ||
      text.includes('checkout');

    if (!isCheckout) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    btn.disabled = true;

    try {
      await applyBeforeCheckout();
    } catch (err) {
      console.error('[GiftSamples] checkout error:', err);
    }

    window.location.href = '/checkout';
  }, true);

  // ─── Limpiar al cargar ───────────────────────────────────────────
  window.addEventListener('load', cleanCart);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) cleanCart();
  });
  if (window.location.pathname === '/cart') cleanCart();

  // ─── Limpiar en eventos del carrito ─────────────────────────────
  document.addEventListener('click', function (e) {
    const drawerTrigger = e.target.closest('[href="#cart-drawer"], [data-drawer="cart"], .header__icon--cart, [aria-controls="CartDrawer"]');
    if (drawerTrigger) setTimeout(cleanCart, 300);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest('.quantity__input')) return;
    setTimeout(cleanCart, 800);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('cart-remove-button button')) return;
    setTimeout(cleanCart, 800);
  });
  document.addEventListener('cart:updated', cleanCart);
  document.addEventListener('cart:refresh', cleanCart);

  // ─── Contador del carrito ────────────────────────────────────────
  function updateCartCount(items) {
    const realCount = items
      ? items.filter(i => !ALL_SAMPLE_IDS.includes(i.variant_id))
             .reduce((sum, i) => sum + i.quantity, 0)
      : null;

    function applyCount(count) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .visually-hidden').forEach(el => {
        el.textContent = count < 100 ? count : '99+';
      });
      document.querySelectorAll('.cart-count-bubble').forEach(el => {
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    if (realCount !== null) {
      applyCount(realCount);
    } else {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => applyCount(
          cart.items.filter(i => !ALL_SAMPLE_IDS.includes(i.variant_id))
                    .reduce((sum, i) => sum + i.quantity, 0)
        ))
        .catch(err => console.error('[GiftSamples] updateCartCount error:', err));
    }
  }

  window.addEventListener('load', () => updateCartCount(null));
  document.addEventListener('cart:updated', e => updateCartCount(e.detail?.cart?.items || null));
  document.addEventListener('cart:refresh', () => updateCartCount(null));

    // ─── Banner: mostrar sempre quan s'obre el drawer ───────────────
  function updateBanner() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const hasEligible = cart.items.some(i =>
          Object.values(PRODUCTS).includes(i.variant_id)
        );
        document.querySelectorAll('#gift-samples-banner').forEach(el => {
          el.style.display = hasEligible ? 'block' : 'none';
        });
      });
  }

  // Escoltar quan el drawer s'obre
  document.addEventListener('click', function(e) {
    if (
      e.target.closest('[href="#cart-drawer"]') ||
      e.target.closest('.cart-count-bubble') ||
      e.target.closest('[data-cart-toggle]') ||
      e.target.closest('.header__icon--cart')
    ) {
      setTimeout(updateBanner, 300);
    }
  });

  // També quan s'afegeix un producte al carrito
  document.addEventListener('cart:refresh', updateBanner);
  document.addEventListener('cart:updated', updateBanner);

})();
